export default "__VITE_ASSET__BpgUthKJ__"